
/* Keep panes visible until their reverse entrance animation has completed. */
window.usAnimatePaneOut = (pane, finish) => {
 if (pane.usExitPending) return pane.usExitPending;
 if (matchMedia('(prefers-reduced-motion: reduce)').matches) { finish(); return Promise.resolve(); }
 const style = getComputedStyle(pane);
 const name = style.animationName;
 let destination;
 const entry = pane.getAnimations().find(animation => animation.animationName);
 if (entry) {
  const first = entry.effect.getKeyframes()[0];
  if (first?.transform && first.transform !== 'none') destination = first.transform;
 }
 if (!destination) {
  if (/left/i.test(name)) destination = 'translateX(-100%)';
  else if (/right/i.test(name)) destination = 'translateX(100%)';
  else if (/up|bottom/i.test(name)) destination = 'translateY(100%)';
 }
 const frames = destination
  ? [{transform:style.transform === 'none' ? 'translate(0,0)' : style.transform}, {transform:destination}]
  : [{opacity:style.opacity}, {opacity:0}];
 const animation = pane.animate(frames, {duration:300,easing:'cubic-bezier(.645,.045,.355,1)',fill:'forwards'});
 pane.usExitPending = animation.finished.catch(() => {}).then(() => {
  finish();
  animation.cancel();
  pane.usExitPending = null;
 });
 return pane.usExitPending;
};
window.usCloseDialog = (pane, value) => {
 if (!pane?.open) return Promise.resolve();
 return window.usAnimatePaneOut(pane, () => pane.close(value));
};
document.addEventListener('cancel', event => {
 const pane = event.target;
 if (!pane.matches?.('dialog.us-wishlist-picker,dialog.us-contact-pane,dialog.us-collection-preview,dialog.us-collection-notify,dialog.us-collection-size-chart')) return;
 event.preventDefault();
 window.usCloseDialog(pane);
}, true);

if (!customElements.get('us-mobile-navigation')) {
  customElements.define('us-mobile-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      document.addEventListener('scroll', event => {
        const gallery = event.target;
        if (!gallery.matches?.('[data-us-packshots]')) return;
        gallery.usSwipeUntil = performance.now() + 300;
        const thumb = gallery.nextElementSibling?.querySelector('span');
        if (thumb && gallery.clientWidth) {
          const count = gallery.querySelectorAll('.product-card__image--primary, .us-packshot-image').length;
          thumb.style.width = (100 / count) + '%';
          const range = gallery.scrollWidth - gallery.clientWidth;
          const step = range > 0 ? Math.max(0, Math.min(1, Math.abs(gallery.scrollLeft) / range)) * (count - 1) : 0;
          thumb.style.transform = 'translateX(' + (step * 100) + '%)';
        }
      }, { ...options, capture: true, passive: true });
      document.addEventListener('click', event => {
        const gallery = event.target.closest?.('[data-us-packshots]');
        if (gallery && performance.now() < (gallery.usSwipeUntil || 0)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { ...options, capture: true });

      document.addEventListener('click', event => this.handleMenuBack(event), { ...options, capture: true });

      this.refresh = this.refresh.bind(this);
      this.schedule = this.schedule.bind(this);
      this.syncOverlay = this.syncOverlay.bind(this);
      this.setupHeader();
      document.fonts?.ready.then(() => { if (this.isConnected) this.sizeMenu(); });
      window.addEventListener('resize', () => this.sizeMenu(), options);
      document.addEventListener('shopify:section:load', () => this.setupHeader(), options);
      window.addEventListener('scroll', this.schedule, { ...options, passive: true });
      window.addEventListener('resize', this.schedule, options);
      window.visualViewport?.addEventListener('resize', this.schedule, options);
      document.addEventListener('dialog:after-show', this.syncOverlay, options);
      document.addEventListener('dialog:after-hide', this.syncOverlay, options);
      this.countObserver = new MutationObserver(() => this.syncCount());
      const count = this.querySelector('cart-count');
      if (count) this.countObserver.observe(count, { childList: true, characterData: true, subtree: true });
      this.syncCount();
      this.syncOverlay();
    }
    handleFilterNavigation(event) {
      if (!matchMedia('(max-width: 999px)').matches) return;
      const target = event.target.closest?.('button, summary');
      const drawer = document.getElementById('facets-drawer');
      if (!target || !drawer) return;
      const groups = [...drawer.querySelectorAll('[data-us-filter-group]')];
      const back = drawer.querySelector('[data-us-filter-back]');
      const list = drawer.querySelector('.accordion-list');
      if (!back || !list) return;
      const reset = () => {
        groups.forEach(group => { group.open = false; group.removeAttribute('data-current'); });
        drawer.removeAttribute('data-filter-subpage');
        back.hidden = true;
      };
      if (target.getAttribute('aria-controls') === 'facets-drawer') {
        reset();
        requestAnimationFrame(() => this.sizeFilterHeight());
        return;
      }
      if (!drawer.contains(target)) return;
      const group = target.closest('[data-us-filter-group]');
      if (target.matches('summary') && group) {
        event.preventDefault();
        event.stopImmediatePropagation();
        reset();
        group.open = true;
        group.setAttribute('data-current', '');
        drawer.setAttribute('data-filter-subpage', '');
        back.hidden = false;
        back.querySelector('[data-us-filter-back-label]').textContent = target.textContent.trim();
        this.slideNavigation(list);
        requestAnimationFrame(() => this.sizeFilterHeight());
        const first = group.querySelector('input:not([type="hidden"]), button, a');
        first?.focus({ preventScroll: true });
      } else if (target.hasAttribute('data-us-filter-back')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const previous = groups.find(item => item.hasAttribute('data-current'));
        reset();
        this.slideNavigation(list, true);
        requestAnimationFrame(() => this.sizeFilterHeight());
        previous?.querySelector('summary')?.focus({ preventScroll: true });
      }
    }
    slideNavigation(element, reverse = false) {
      return element.animate(
        [{ transform: reverse ? 'translateX(-100%)' : 'translateX(100%)' }, { transform: 'translateX(0)' }],
        { duration: matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
      );
    }
    async handleMenuBack(event) {
      if (!matchMedia('(max-width: 999px)').matches) return;
      const button = event.target.closest?.('#sidebar-menu .header-sidebar__back-button[data-action="close-panel"]');
      if (!button) return;
      const panel = button.closest('.header-sidebar__sub-panel');
      const expanded = panel?.querySelectorAll('details[open]:not([aria-expanded="false"])');
      if (!expanded?.length) {
        const menu=button.closest('header-sidebar');
        const container=panel?.closest('header-sidebar-collapsible-panel');
        if(!panel||!container||menu.usBackPending)return;
        event.preventDefault();
        event.stopImmediatePropagation();
        menu.usBackPending=true;
        const duration=matchMedia('(prefers-reduced-motion: reduce)').matches?0:200;
        const main=menu.querySelector('.header-sidebar__main-panel');
        container.getAnimations().forEach(animation=>animation.cancel());
        container.style.opacity='1';
        container.style.transform='translateX(0)';
        panel.getAnimations({subtree:true}).forEach(animation=>animation.cancel());
        main.getAnimations().forEach(animation=>animation.cancel());
        main.style.opacity='1';
        main.style.transform='translateX(0)';
        menu.classList.add('us-nav-going-back');
        const options={duration,easing:'cubic-bezier(.22,.61,.36,1)',fill:'both'};
        const animations=[
          panel.animate([{transform:'translateX(0)'},{transform:'translateX(100%)'}],options),
          main.animate([{transform:'translateX(-25%)'},{transform:'translateX(0)'}],options)
        ];
        Promise.all(animations.map(animation=>animation.finished.catch(()=>{}))).then(()=>{
          panel.hidden=true;
          const originalLeave=container.createLeaveAnimationControls;
          container.createLeaveAnimationControls=()=>({finished:Promise.resolve(),finish(){}});
          container.removeAttribute('aria-activedescendant');
          queueMicrotask(()=>{container.createLeaveAnimationControls=originalLeave;});
          menu.querySelectorAll('.header-sidebar__main-panel [aria-expanded="true"]').forEach(control=>control.setAttribute('aria-expanded','false'));
          animations.forEach(animation=>animation.cancel());
          menu.classList.remove('us-nav-going-back');
          menu.revealItems(false);
          menu.usBackPending=false;
        });
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      const summary = expanded[0].querySelector('summary');
      const menu=button.closest('header-sidebar');
      if(menu.usBackPending)return;
      menu.usBackPending=true;
      const list=panel.querySelector('.header-sidebar__linklist');
      if(!list){menu.usBackPending=false;return;}
      list.getAnimations({subtree:true}).forEach(animation=>animation.cancel());
      const outgoing=list.cloneNode(true);
      outgoing.setAttribute('aria-hidden','true');
      outgoing.inert=true;
      outgoing.removeAttribute('id');
      outgoing.querySelectorAll('[id]').forEach(node=>node.removeAttribute('id'));
      const bounds=list.getBoundingClientRect();
      const parentBounds=panel.getBoundingClientRect();
      const oldPosition=panel.style.position;
      panel.style.position='relative';
      Object.assign(outgoing.style,{
        position:'absolute',left:(bounds.left-parentBounds.left)+'px',
        top:(bounds.top-parentBounds.top)+'px',width:bounds.width+'px',
        height:bounds.height+'px',margin:'0',zIndex:'3',background:'#fff',
        pointerEvents:'none',overflow:'hidden'
      });
      panel.append(outgoing);
      try{
        await Promise.all([...expanded].map(details=>{
          if(typeof details.toggle==='function')return details.toggle(false);
          details.open=false;
        }));
        list.scrollTop=0;
        const options={duration:matchMedia('(prefers-reduced-motion: reduce)').matches?0:220,easing:'cubic-bezier(.22,.61,.36,1)',fill:'both'};
        const animations=[
          outgoing.animate([{transform:'translateX(0)'},{transform:'translateX(100%)'}],options),
          list.animate([{transform:'translateX(-25%)',opacity:1},{transform:'translateX(0)',opacity:1}],options)
        ];
        await Promise.all(animations.map(animation=>animation.finished.catch(()=>{})));
        outgoing.remove();
        animations.forEach(animation=>animation.cancel());
        summary?.focus({preventScroll:true});
      }finally{
        outgoing.remove();
        panel.style.position=oldPosition;
        menu.usBackPending=false;
      }
    }
    setupHeader() {
      this.header = document.querySelector('.shopify-section--header');
      const source = this.header?.querySelector('.header__logo > a');
      if (!source) return;
      this.logo?.remove();
      this.logo = source.cloneNode(true);
      this.logo.classList.add('us-mobile-logo');
      this.append(this.logo);
      const image = source.querySelector('.header__logo-image');
      const width = image ? parseFloat(getComputedStyle(image).width) : 180;
      this.logo.style.setProperty('--us-mobile-logo-width', `${width || 180}px`);
      const search = this.header.querySelector('header-search');
      const searchControl = this.querySelector('[data-us-search]');
      searchControl.setAttribute('aria-controls', 'us-search-drawer');
      searchControl.setAttribute('aria-expanded', 'false');
      this.querySelector('[data-us-menu]').hidden = !document.getElementById('sidebar-menu');
      document.documentElement.classList.add('us-mobile-ready');
      document.documentElement.classList.toggle('us-mobile-home', this.hasAttribute('data-homepage'));
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(this.header);
      this.resizeObserver.observe(this.querySelector('.us-mobile-bar'));
      this.refresh();
      this.sizeMenu();
      this.menuHeightObserver?.disconnect();
      this.menuStateObserver?.disconnect();
      const menu = document.getElementById('sidebar-menu');
      if (menu) {
        customElements.whenDefined('header-sidebar').then(() => {
          if (!this.isConnected || menu.usGroupRevealInstalled) return;
          const originalReveal = menu.revealItems.bind(menu);
          menu.revealItems = (withDelay = false) => {
            if (!matchMedia('(max-width: 999px)').matches) return originalReveal(withDelay);
            const panel = menu.querySelector('.header-sidebar__main-panel');
            if (!panel) return originalReveal(withDelay);
            panel.getAnimations().forEach(animation => animation.cancel());
            panel.querySelectorAll('.header-sidebar__linklist li, .header-sidebar__footer').forEach(item => {
              item.getAnimations().forEach(animation => animation.cancel());
              item.style.opacity = '1';
              item.style.transform = 'none';
            });
            panel.style.opacity = '1';
            panel.style.transform = 'translateX(0)';
            const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
            return panel.animate(
              [{ transform: withDelay ? 'translateX(-100%)' : 'translateX(0)', opacity: 1 }, { transform: 'translateX(0)', opacity: 1 }],
              { duration: reduced || !withDelay ? 0 : 300, delay: 0, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'backwards' }
            );
          };
          menu.usGroupRevealInstalled = true;
        });
        customElements.whenDefined('accordion-disclosure').then(() => {
          if (!this.isConnected) return;
          menu.querySelectorAll('details[is="accordion-disclosure"]').forEach(details => {
            if (details.usSlideInstalled) return;
            const originalShow = details.createShowAnimationControls.bind(details);
            const originalHide = details.createHideAnimationControls.bind(details);
            details.createShowAnimationControls = () => {
              if (!matchMedia('(max-width: 999px)').matches) return originalShow();
              return this.slideNavigation(details.contentElement);
            };
            details.createHideAnimationControls = () => {
              if (!matchMedia('(max-width: 999px)').matches) return originalHide();
              return details.contentElement.animate([{ opacity: 1 }, { opacity: 1 }], { duration: 0 });
            };
            details.usSlideInstalled = true;
          });
        });
        const update = () => {
          cancelAnimationFrame(this.menuHeightFrame);
          this.menuHeightFrame = requestAnimationFrame(() => this.sizeMenuHeight());
        };
        this.menuHeightObserver = new ResizeObserver(update);
        menu.querySelectorAll('.us-nav-main-content, .header-sidebar__linklist, .header-sidebar__sub-panel, .header-sidebar__footer').forEach(element => this.menuHeightObserver.observe(element));
        this.menuStateObserver = new MutationObserver(records => {
          if (matchMedia('(max-width: 999px)').matches) {
            const changedPanel = records.some(record => record.attributeName === 'aria-activedescendant');
            const opened = [...records].reverse().find(record =>
              record.target.matches('details') &&
              (record.attributeName === 'open' || record.attributeName === 'aria-expanded') &&
              record.target.open && record.target.getAttribute('aria-expanded') !== 'false'
            )?.target;
            if (changedPanel || opened) {
              menu.querySelectorAll('details[open]').forEach(details => {
                if (details === opened || (opened && details.contains(opened))) return;
                if (details.getAttribute('aria-expanded') === 'false') return;
                if (typeof details.toggle === 'function') details.toggle(false);
                else details.open = false;
              });
            }
          }
          update();
        });
        this.menuStateObserver.observe(menu, { subtree: true, attributes: true, attributeFilter: ['open', 'hidden', 'aria-activedescendant', 'aria-expanded'] });
        update();
      }
    }
    sizeMenuHeight() {
      const menu = document.getElementById('sidebar-menu');
      if (!menu || !matchMedia('(max-width: 999px)').matches) return;
      const panel = menu.querySelector('.header-sidebar__collapsible-panel');
      const activeId = panel?.getAttribute('aria-activedescendant');
      const active = activeId ? document.getElementById(activeId) : null;
      const content = menu.querySelector('.us-nav-main-content') || menu.querySelector('.header-sidebar__main-panel .header-sidebar__linklist');
      if (!content) return;
      const row = content.querySelector('.header-sidebar__linklist-button');
      const rowHeight = Math.max(44, row?.offsetHeight || 48);
      const footer = menu.querySelector('.header-sidebar__footer');
      let height = content.offsetHeight + (footer?.offsetHeight || 0) + 64;
      if (active && !active.hidden) {
        const list = active.querySelector(':scope > .header-sidebar__linklist');
        const promo = active.querySelector(':scope > .header-sidebar__promo');
        const back = active.querySelector(':scope > .header-sidebar__back-button');
        height = this.naturalListHeight(list) + (promo?.offsetHeight || 0) + (back?.offsetHeight || 0) + 64;
      }
      menu.style.setProperty('--us-menu-row-height', rowHeight + 'px');
      menu.style.setProperty('--us-menu-height', Math.ceil(height) + 'px');
      requestAnimationFrame(() => {
        if (active || !menu.hasAttribute('open')) return;
        const socials = menu.querySelector('.us-nav-socials');
        const divider = menu.querySelector('.us-nav-showroom');
        const account = menu.querySelector('.header-sidebar__footer > a');
        if (!socials || !divider || !account || !account.offsetHeight) return;
        const previous = parseFloat(socials.style.getPropertyValue('--us-social-offset')) || 0;
        const icons = socials.getBoundingClientRect();
        const top = divider.getBoundingClientRect().bottom;
        const accountBox = account.getBoundingClientRect();
        const target = (top + accountBox.top + accountBox.height / 2) / 2;
        const offset = target - (icons.top + icons.height / 2 - previous);
        const scroller = socials.closest('.header-sidebar__scroller');
        const room = scroller ? scroller.getBoundingClientRect().bottom - icons.bottom + previous : offset;
        socials.style.setProperty('--us-social-offset', Math.max(0, Math.min(offset, room)).toFixed(2) + 'px');
      });
    }
    naturalListHeight(list) {
      if (!list) return 0;
      const style = getComputedStyle(list);
      const children = [...list.children].filter(child => getComputedStyle(child).display !== 'none');
      return children.reduce((height, child) => {
        const childStyle = getComputedStyle(child);
        return height + child.getBoundingClientRect().height + (parseFloat(childStyle.marginTop) || 0) + (parseFloat(childStyle.marginBottom) || 0);
      }, (parseFloat(style.paddingTop) || 0) + (parseFloat(style.paddingBottom) || 0))
        + Math.max(0, children.length - 1) * (parseFloat(style.rowGap) || 0);
    }
    sizeFilterHeight() {
      const drawer = document.getElementById('facets-drawer');
      if (!drawer || !matchMedia('(max-width: 999px)').matches) return;
      const list = drawer.querySelector('.accordion-list');
      const footer = drawer.querySelector('[slot="footer"]');
      if (!list || !footer || !drawer.hasAttribute('open')) return;
      const height = Math.ceil(this.naturalListHeight(list) + footer.getBoundingClientRect().height + 92);
      drawer.style.setProperty('--us-filter-height', height + 'px');
    }
    sizeMenu() {
      const menu = document.getElementById('sidebar-menu');
      if (!menu || !matchMedia('(max-width: 999px)').matches) return;
      const probe = document.createElement('span');
      probe.style.cssText = 'position:fixed;visibility:hidden;pointer-events:none;white-space:pre;width:max-content;';
      document.body.append(probe);
      let widest = 0;
      for (const item of menu.querySelectorAll('.header-sidebar__linklist-button, .header-sidebar__back-button, .header-sidebar__nested-linklist > a')) {
        const style = getComputedStyle(item);
        for (const property of ['fontFamily', 'fontSize', 'fontWeight', 'fontStyle', 'fontStretch', 'fontVariant', 'letterSpacing', 'textTransform']) probe.style[property] = style[property];
        probe.textContent = item.textContent.trim().replace(/\s+/g, ' ');
        const icon = item.querySelector('svg, .animated-plus');
        const extra = icon ? (parseFloat(getComputedStyle(icon).width) || 12) + (parseFloat(style.columnGap) || 10) : 0;
        const nested = item.parentElement.classList.contains('header-sidebar__nested-linklist') ? 12 : 0;
        widest = Math.max(widest, probe.getBoundingClientRect().width + extra + nested);
      }
      probe.style.font = getComputedStyle(menu).font;
      probe.style.letterSpacing = 'normal';
      probe.textContent = '00';
      const padding = probe.getBoundingClientRect().width;
      probe.remove();
      if (widest) menu.style.setProperty('--us-menu-width', `${Math.ceil(widest + padding + 2)}px`);
    }
    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.refresh(); });
    }
    refresh() {
      if (!this.header || !this.logo) return;
      const mobile = matchMedia('(max-width: 999px)').matches;
      if (!mobile) return;
      this.logo.toggleAttribute('data-scrolled', window.scrollY > 38);
      const headerRect = this.header.getBoundingClientRect();
      const linkRect = this.header.querySelector('.header__logo').getBoundingClientRect();
      const top = Math.max(0, headerRect.top) + (headerRect.height - Math.max(44, linkRect.height)) / 2;
      this.logo.style.setProperty('--us-mobile-logo-top', `${Math.max(0, top)}px`);
      const barHeight = this.querySelector('.us-mobile-bar').getBoundingClientRect().height;
      document.documentElement.style.setProperty('--us-mobile-bar-height', '0px');
      document.documentElement.style.setProperty('--us-top-bar-height', `${barHeight}px`);
      this.sizeMenuHeight();
      this.sizeFilterHeight();
      const viewport = window.visualViewport;
      const editing = document.activeElement?.matches('input, textarea, [contenteditable="true"]');
      const keyboardOpen = Boolean(viewport && editing && window.innerHeight - viewport.height > 150);
      document.documentElement.classList.toggle('us-mobile-keyboard', keyboardOpen);
      const search = this.header.querySelector('header-search');
      if (search) {
        const bottom = keyboardOpen ? Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop) : 0;
        search.style.setProperty('--us-search-bottom', bottom + 'px');
        search.style.setProperty('--us-search-max-height', Math.max(56, (viewport?.height || window.innerHeight) - (keyboardOpen ? 0 : barHeight) - 24) + 'px');
      }
    }
    syncCount() {
      const count = this.querySelector('cart-count');
      count?.toggleAttribute('data-empty', Number(count.textContent.trim()) === 0);
    }
    syncOverlay() {
      document.documentElement.classList.toggle('us-mobile-overlay', Boolean(document.querySelector('header-sidebar[open], header-search[open], cart-drawer[open], x-modal[open], x-drawer[open]')));
      this.schedule();
    }
    disconnectedCallback() {
      this.abort.abort();
      this.resizeObserver?.disconnect();
      this.countObserver?.disconnect();
      this.menuHeightObserver?.disconnect();
      this.menuStateObserver?.disconnect();
      cancelAnimationFrame(this.menuHeightFrame);
      cancelAnimationFrame(this.frame);
      document.documentElement.classList.remove('us-mobile-ready', 'us-mobile-home', 'us-mobile-overlay', 'us-mobile-keyboard');
      document.documentElement.style.removeProperty('--us-mobile-bar-height');
    }
  });
}

(function () {
  if (window.usCollectionSwipeHint) return;
  window.usCollectionSwipeHint = true;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting || entry.intersectionRatio < 0.65) return;
      const gallery = entry.target;
      observer.unobserve(gallery);
      if (motion.matches || Math.abs(gallery.scrollLeft) > 1) return;
      const first = gallery.querySelector('.product-card__image--primary');
      if (!first) return;
      const play = () => {
        if (!gallery.isConnected || motion.matches || Math.abs(gallery.scrollLeft) > 1) return;
        const distance = Math.min(56, gallery.clientWidth * 0.24);
        const animations = Array.from(gallery.querySelectorAll('.product-card__image--primary, .us-packshot-image')).map(image => image.animate([
          { translate: '0px 0px', offset: 0 },
          { translate: '-' + distance + 'px 0px', offset: 0.4 },
          { translate: '-' + distance + 'px 0px', offset: 0.6 },
          { translate: '0px 0px', offset: 1 }
        ], { duration: 1000, delay: 250, easing: 'ease-in-out', iterations: 1 }));
        const cancel = () => animations.forEach(animation => animation.cancel());
        gallery.addEventListener('pointerdown', cancel, { once: true, passive: true });
        Promise.allSettled(animations.map(animation => animation.finished)).then(() => gallery.removeEventListener('pointerdown', cancel));
      };
      if (first.complete) play();
      else first.addEventListener('load', play, { once: true });
    });
  }, { threshold: 0.65 });
  const card = document.querySelector('.shopify-section--main-collection .product-list .product-card');
  const gallery = card?.querySelector('[data-us-packshots]');
  if (gallery && gallery.querySelectorAll('.product-card__image--primary, .us-packshot-image').length > 1) observer.observe(gallery);
})();

(function () {
  let drag;
  document.addEventListener('dragstart', event => {
    if (event.target.closest?.('[data-us-packshots]')) event.preventDefault();
  });
  document.addEventListener('pointerdown', event => {
    const gallery = event.target.closest?.('[data-us-packshots]');
    if (!gallery || event.pointerType !== 'mouse' || event.button !== 0 || !matchMedia('(min-width: 1000px)').matches) return;
    drag = { gallery, id: event.pointerId, x: event.clientX, scroll: gallery.scrollLeft, moved: false };
  });
  document.addEventListener('pointermove', event => {
    if (!drag || drag.id !== event.pointerId) return;
    const delta = event.clientX - drag.x;
    if (!drag.moved && Math.abs(delta) < 5) return;
    if (!drag.moved) {
      drag.moved = true;
      drag.gallery.setAttribute('data-dragging', '');
      drag.gallery.setPointerCapture(event.pointerId);
    }
    event.preventDefault();
    drag.gallery.scrollLeft = drag.scroll - delta;
    drag.gallery.usSwipeUntil = performance.now() + 400;
  }, { passive: false });
  const end = event => {
    if (!drag || drag.id !== event.pointerId) return;
    const { gallery, moved } = drag;
    drag = null;
    gallery.removeAttribute('data-dragging');
    if (gallery.hasPointerCapture(event.pointerId)) gallery.releasePointerCapture(event.pointerId);
    if (moved) {
      gallery.usSwipeUntil = performance.now() + 400;
      const width = gallery.clientWidth;
      if (width) gallery.scrollTo({ left: Math.round(gallery.scrollLeft / width) * width, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  };
  document.addEventListener('pointerup', end);
  document.addEventListener('pointercancel', end);
  document.addEventListener('keydown', event => {
    const gallery = event.target.closest?.('[data-us-packshots]');
    if (!gallery || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    gallery.scrollBy({ left: (event.key === 'ArrowRight' ? 1 : -1) * gallery.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
})();

document.addEventListener('click', event => {
  const button = event.target.closest?.('[data-us-packshot-step]');
  if (!button) return;
  const gallery = button.closest('.product-card__figure')?.querySelector('[data-us-packshots]');
  if (!gallery || !gallery.clientWidth) return;
  event.preventDefault();
  const images = Array.from(gallery.querySelectorAll('.product-card__image--primary, .us-packshot-image'));
  images.forEach(image => image.getAnimations().forEach(animation => animation.cancel()));
  const current = Math.round(gallery.scrollLeft / gallery.clientWidth);
  const next = (current + Number(button.dataset.usPackshotStep) + images.length) % images.length;
  gallery.scrollTo({ left: next * gallery.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
});

(() => {
 const pane = document.getElementById('us-contact-pane');
 if (!pane || pane.dataset.ready) return;
 pane.dataset.ready = 'true';
 let trigger, overflow, returnMenu, opening = false;
 const mobile = matchMedia('(max-width:999px)');
 document.addEventListener('click', async event => {
  if (!mobile.matches || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target.closest?.('a[href]');
  if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
  const url = new URL(link.href, location.href);
  if (url.origin !== location.origin || !/\/pages\/contact-us\/?$/.test(url.pathname)) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (pane.open || opening) return;
  opening = true;
  trigger = link;
  const menu = document.getElementById('sidebar-menu');
  returnMenu = menu?.hasAttribute('open') ? menu : null;
  try {
   // Release the menu's focus trap and outside-click handlers before opening Contact.
   if (returnMenu) await returnMenu.hide();
   if (!mobile.matches) { returnMenu = null; return; }
   overflow = document.documentElement.style.overflow;
   document.documentElement.style.overflow = 'hidden';
   pane.showModal();
  } finally { opening = false; }
 }, true);
 pane.querySelector('[data-us-contact-close]').addEventListener('click', event => {
  event.preventDefault();
  event.stopPropagation();
  window.usCloseDialog(pane);
 });
 pane.addEventListener('click', event => {
  const bounds = pane.getBoundingClientRect();
  if (event.target === pane && (event.clientY < bounds.top || event.clientY > bounds.bottom || event.clientX < bounds.left || event.clientX > bounds.right)) window.usCloseDialog(pane);
 });
 pane.addEventListener('close', () => {
  document.documentElement.style.overflow = overflow || '';
  const openedFromMenu = Boolean(returnMenu);
  returnMenu = null;
  if (openedFromMenu) {
   document.querySelector('.header__primary-nav [aria-controls="sidebar-menu"]')?.focus({preventScroll:true});
  } else if (trigger?.isConnected && !trigger.closest('header-sidebar')) {
   trigger.focus({preventScroll:true});
  }
 });
 mobile.addEventListener('change', () => {
  if (!mobile.matches) {
   returnMenu = null;
   if (pane.open) window.usCloseDialog(pane);
  }
 });
})();

/* Desktop cart and wishlist open from the right; other navigation panes open from the left. */
document.addEventListener('dialog:before-show', event => {
 const pane=event.target;
 if(!pane.matches?.('.header-sidebar,.us-fit-drawer,.facets-drawer,.us-search-drawer,.us-wishlist-drawer,.cart-drawer,.header-search'))return;
 const fromRight=pane.matches('.cart-drawer')||(pane.matches('.us-wishlist-drawer')&&matchMedia('(min-width:1000px)').matches)||(pane.matches('.header-search,.us-search-drawer')&&matchMedia('(max-width:999px)').matches);
 const offscreen=fromRight?'translateX(100%)':'translateX(-100%)';
 pane.setAttribute('open-from',fromRight?'right':'left');
 const animatePane=entering=>{
  const duration=matchMedia('(prefers-reduced-motion: reduce)').matches?0:300;
  const content=pane.getShadowPartByName('content');
  const overlay=pane.getShadowPartByName('overlay');
  if(entering){
   pane.usNavExitAnimations?.forEach(animation=>animation.cancel());
   pane.usNavExitAnimations=null;
  }
  if(pane.matches('.header-sidebar,.us-fit-drawer')){
   const panel=pane.querySelector('.header-sidebar__main-panel');
   if(panel&&entering){
    panel.getAnimations().forEach(animation=>animation.cancel());
    panel.style.opacity='1';
    panel.style.transform='translateX(0)';
   }
  }
  const animations=[
   content.animate({transform:entering?[offscreen,'translateX(0)']:['translateX(0)',offscreen]},{duration,easing:'cubic-bezier(.645,.045,.355,1)',fill:'both'}),
   ...(overlay?[overlay.animate({opacity:entering?[0,1]:[1,0]},{duration,fill:'both'})]:[])
  ];
  return{
   finished:Promise.all(animations.map(animation=>animation.finished)).then(()=>{
    if(!entering)pane.usNavExitAnimations=animations;
    else animations.forEach(animation=>animation.cancel());
   }),
   finish(){animations.forEach(animation=>animation.finish());}
  };
 };
 pane.createEnterAnimationControls=()=>animatePane(true);
 pane.createLeaveAnimationControls=()=>animatePane(false);
},true);

document.addEventListener('click', async event=>{
 const button=event.target.closest?.('[data-us-nav-wishlist]');
 if(!button)return;
 event.preventDefault();event.stopImmediatePropagation();
 const menu=document.getElementById('sidebar-menu');
 const wishlist=document.getElementById('us-wishlist-drawer');
 if(!wishlist)return;
 if(menu?.hasAttribute('open'))await menu.hide();
 wishlist.show();
},true);

document.addEventListener('keydown', event=>{
 if(event.key==='Tab')document.documentElement.classList.add('us-keyboard-focus');
},true);
document.addEventListener('pointerdown', ()=>{
 document.documentElement.classList.remove('us-keyboard-focus');
},true);

/* Product size guides open and close as bottom sheets on every screen size. */
document.addEventListener('dialog:before-show', event=>{
 const pane=event.target;
 if(!pane.matches?.('x-modal'))return;
 const title=pane.querySelector('[slot="header"]')?.textContent||'';
 const labels=[...document.querySelectorAll('[aria-controls]')].filter(button=>button.getAttribute('aria-controls')===pane.id).map(button=>button.textContent).join(' ');
 if(!/^(size-chart-|us-size-modal-)/.test(pane.id)&&!/size guide|size chart|sizing|fit guide/i.test(title+' '+labels))return;
 pane.classList.add('us-product-size-guide');
 const animateGuide=entering=>{
  if(entering){pane.usGuideExitAnimations?.forEach(animation=>animation.cancel());pane.usGuideExitAnimations=null;}
  const duration=matchMedia('(prefers-reduced-motion: reduce)').matches?0:300;
  const content=pane.getShadowPartByName('content');
  const overlay=pane.getShadowPartByName('overlay');
  const animations=[
   content.animate({transform:entering?['translateY(100%)','translateY(0)']:['translateY(0)','translateY(100%)']},{duration,easing:'cubic-bezier(.645,.045,.355,1)',fill:'both'}),
   ...(overlay?[overlay.animate({opacity:entering?[0,1]:[1,0]},{duration,fill:'both'})]:[])
  ];
  return{
   finished:Promise.all(animations.map(animation=>animation.finished)).then(()=>{if(entering)animations.forEach(animation=>animation.cancel());else pane.usGuideExitAnimations=animations;}),
   finish(){animations.forEach(animation=>animation.finish());}
  };
 };
 pane.createEnterAnimationControls=()=>animateGuide(true);
 pane.createLeaveAnimationControls=()=>animateGuide(false);
},true);

/* Add the current product image to the app-owned restock popup. */
(()=>{
 const selector='[data-essential-preorder-element="back-in-stock-pop-up-container"]';
 const closeSelector='[data-essential-preorder-element="back-in-stock-pop-up-close"]';
 const decorate=pane=>{
  const title=pane.querySelector('[data-essential-preorder-element="back-in-stock-pop-up-title"]');
  if(title && title.textContent.trim()==='This size is sold out. Be the first to know when it returns.' && !title.querySelector('br')){
   title.replaceChildren(document.createTextNode('This size is sold out.'),document.createElement('br'),document.createTextNode('Be the first to know when it returns.'));
  }
  const description=pane.querySelector('[data-essential-preorder-element="back-in-stock-pop-up-description"]');
  const activeUnit=document.querySelector('[data-us-size] .us-size__tab[aria-selected="true"]')?.dataset.unit
   ||document.querySelector('us-wishlist')?.dataset.defaultUnit||'UK';
  if(description){
   const walker=document.createTreeWalker(description,NodeFilter.SHOW_TEXT);
   let node;
   while((node=walker.nextNode())){
    const updated=node.nodeValue.replace(/(?:UK|EU|US)\s*\d+(?:[.,]\d+)?(?:\s*\/\s*(?:UK|EU|US)\s*\d+(?:[.,]\d+)?)+/gi,combined=>{
     const sizes=combined.split('/').map(value=>value.trim());
     const selected=sizes.find(value=>value.toUpperCase().startsWith(activeUnit.toUpperCase()))||sizes[0];
     return selected.replace(/^(UK|EU|US)\s*/i,'$1 ');
    });
    if(updated!==node.nodeValue)node.nodeValue=updated;
   }
  }
  if(pane.querySelector('.us-essential-notify-image'))return;
  const source=document.querySelector('product-gallery img');
  if(!source)return;
  const photo=document.createElement('img');
  photo.className='us-essential-notify-image';photo.alt=source.alt;
  photo.width=600;photo.height=600;
  const url=new URL(source.currentSrc||source.src,location.href);url.searchParams.set('width','600');photo.src=url.href;
  photo.addEventListener('error',()=>photo.remove(),{once:true});
  if(description)description.before(photo);
  else pane.querySelector('[data-essential-preorder-element="back-in-stock-pop-up-header"]')?.after(photo);
 };
 const scan=node=>{
  if(!(node instanceof Element)){const pane=node.parentElement?.closest(selector);if(pane)decorate(pane);return;}
  const parentPane=node.closest(selector);if(parentPane)decorate(parentPane);
  if(node.matches(selector))decorate(node);
  node.querySelectorAll(selector).forEach(decorate);
 };
 scan(document.body);
 new MutationObserver(records=>records.forEach(record=>{if(record.type==='characterData')scan(record.target);else record.addedNodes.forEach(scan);})).observe(document.body,{childList:true,characterData:true,subtree:true});
 const replay=new WeakSet();
  const close=pane=>{
  const button=pane.querySelector(closeSelector);
  if(!button||pane.usExitPending)return;
  pane.usExitPending=true;
  const finish=()=>{replay.add(button);button.click();replay.delete(button);pane.usExitPending=false;};
  if(matchMedia('(prefers-reduced-motion: reduce)').matches){finish();return;}
  pane.classList.add('us-notify-closing');
  window.setTimeout(finish,310);
 };
document.addEventListener('click',event=>{
  const button=event.target.closest?.(closeSelector);
  if(!button||replay.has(button))return;
  event.preventDefault();event.stopImmediatePropagation();close(button.closest(selector));
 },true);
 document.addEventListener('keydown',event=>{
  if(event.key!=='Escape')return;
  const pane=document.querySelector(selector);
  if(!pane)return;
  event.preventDefault();event.stopImmediatePropagation();close(pane);
 },true);
})();

document.addEventListener('click',event=>{
 const button=event.target.closest?.('[data-us-filter-clear-all]');
 if(!button)return;
 button.setAttribute('data-just-cleared','');
 button.addEventListener('pointerleave',()=>button.removeAttribute('data-just-cleared'),{once:true});
 const form=button.closest('facets-drawer')?.querySelector('form[is="facets-form"]');
 if(!form)return;
 form.querySelectorAll('input[name^="filter."]').forEach(input=>{
  if(input.type==='checkbox'||input.type==='radio')input.checked=false;
  else input.value='';
 });
 form.querySelectorAll('price-range').forEach(range=>{
  const sliders=range.querySelectorAll('input[type="range"]');
  sliders.forEach((input,index)=>{
   input.value=index===0?input.min:input.max;
   input.parentElement.style.setProperty(index===0?'--range-min':'--range-max',index===0?'0%':'100%');
  });
 });
 form.querySelectorAll('details[open]').forEach(group=>{group.open=false;});
 form.dispatchEvent(new Event('change',{bubbles:true}));
});

/* Align the navigation close control with the header menu icon. */
(() => {
 const alignPaneClose = () => {
  const trigger = document.querySelector('.header__primary-nav [aria-controls="sidebar-menu"]');
  if (!trigger) return;
  const icon = trigger.querySelector('svg') || trigger;
  const rect = icon.getBoundingClientRect();
  if (!rect.width || rect.bottom < 0) return;
  const root = document.documentElement;
  root.style.setProperty('--us-menu-close-left', Math.max(0, rect.left + rect.width / 2 - 22) + 'px');
  root.style.setProperty('--us-menu-close-top', Math.max(8, rect.top + rect.height / 2 - 22) + 'px');
 };
 document.addEventListener('dialog:before-show', alignPaneClose, true);
 window.addEventListener('resize', alignPaneClose, {passive:true});
 alignPaneClose();
})();

;(() => {
 function viewport(){const v=window.visualViewport;const height=v?.height||window.innerHeight;const bottom=Math.max(0,window.innerHeight-((v?.offsetTop||0)+height));document.documentElement.style.setProperty('--us-notify-height',height+'px');document.documentElement.style.setProperty('--us-notify-bottom',bottom+'px');}
 document.addEventListener('click',event=>{const target=event.target instanceof Element?event.target:null;if(!target?.matches('[data-essential-preorder-element="back-in-stock-pop-up-overlay"],[data-essential-preorder-element="back-in-stock-pop-up-wrapper"]'))return;const close=document.querySelector('[data-essential-preorder-element="back-in-stock-pop-up-close"]');if(!close)return;event.preventDefault();event.stopImmediatePropagation();close.click();},true);
 window.addEventListener('resize',viewport,{passive:true});window.visualViewport?.addEventListener('resize',viewport,{passive:true});window.visualViewport?.addEventListener('scroll',viewport,{passive:true});viewport();
})();
